/**
 * Separates the query params from the redirect url
 * @param redirectUrl - The redirect url
 * @example redirect=causes/david || redirect=causes/david?cause_id=123
 * @returns The redirect url and the query params
 */
const separateQueryParamsFromRedirectUrl = (redirectUrl: string) => {
  const [_redirectUrl, queryParams] = redirectUrl.split('?');
  const queryParamsObject = queryParams ? new URLSearchParams(queryParams) : new URLSearchParams();
  return { redirectUrl: _redirectUrl, queryParams: queryParamsObject };
};

export { separateQueryParamsFromRedirectUrl };
